import React from 'react';
import EssaySendSidebar from './EssaySendSidebar';
import EssaySendContent from './EssaySendContent';
import getAuthorityLevel from 'src/app/utils/getAuthorityLevel';
import Error404 from 'src/app/components/Error404';

export default function EssaySend({ essayId, studentId }) {
  const authorityLevel = getAuthorityLevel();

  const isAdmin = authorityLevel !== 'student';

  if (!isAdmin && studentId) return <Error404 />;
  if (isAdmin && !studentId) return <Error404 />;
  return (
    <div>
      <EssaySendContent
        essayId={essayId}
        studentId={studentId}
      />
    </div>
  );
}
